import { render, staticRenderFns } from "./VisasAndClaimsEd.vue?vue&type=template&id=149011a2&scoped=true&"
import script from "./VisasAndClaimsEd.vue?vue&type=script&lang=js&"
export * from "./VisasAndClaimsEd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149011a2",
  null
  
)

export default component.exports